'use client';

import React from 'react';
import { useLang } from './LanguageContext';

export default function MarqueeBar() {
  const { t } = useLang();
  const text = t('marquee');

  return (
    <div className="py-4 border-y overflow-hidden" style={{ borderColor: 'rgba(201,168,76,0.15)', background: 'rgba(201,168,76,0.04)' }}>
      <div className="whitespace-nowrap">
        <span className="animate-marquee">
          {Array.from({ length: 4 })?.map((_, i) => (
            <span
              key={i}
              className="text-gold/60 text-sm font-bold tracking-widest uppercase px-4"
            >
              {text}
            </span>
          ))}
        </span>
      </div>
    </div>
  );
}